// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airline-hover[data-v-1138810c]{border-radius:8px}.airline-hover[data-v-1138810c]:hover{background-color:rgba(180,213,240,.4039215686)}", ""]);
// Exports
module.exports = exports;
